// removed by extract-text-webpack-plugin
module.exports = {"cropper-tool":"_3kGTmY0bW _248jSnXOU g56_TM3Gb _3sVe8CQCV _2BZVi1Y86 _3fTgVz4e7 _3RaCeaMxa","header":"_3SkwbhBl0 _10XSv52kH g56_TM3Gb _3sVe8CQCV _2BZVi1Y86 _1Kb3c6aeJ uXtcc4d5z _19D5W2N5e _1vKzJd4mF _3RaCeaMxa _2ytTHqVtN","header_item":"_3coquEtNp dad3lEPer IDaGOTzdV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/cropper-tool/cropper-tool.css
 ** module id = 2091
 ** module chunks = 0
 **/